import { combineReducers } from '@reduxjs/toolkit';
import modalReducer from '@spa/shared/store/reducers/modal';
import pageReducer from '@spa/shared/store/reducers/page';
import profileReducer from '@spa/shared/store/reducers/profile';
import trackingReducer from '@spa/shared/store/reducers/tracking';
import offerReducer from './offer';
import locationReducer from './location';
var reducers = combineReducers({
  modal: modalReducer,
  tracking: trackingReducer,
  profile: profileReducer,
  offer: offerReducer,
  location: locationReducer,
  page: pageReducer
});
export default reducers;